module.exports = __webpack_public_path__ + "static/media/fly0281.678ba3d5.webp";